import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails,
  DriverResponseDTO,
  GridRequestDto
} from '../../interfaces/apiInterfaces';

export class GetAllDriverCommand extends IRequestCommand<
  IGetAllDriverResponse,
  ErrorDetails,
  IGetAllDriversCommandParameters
> {
  
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl =
    'carriers/{carrierUserId}/drivers/allDrivers';
  
    constructor (){
      super();
    }
  
    public override setParameters(parameters: IGetAllDriversCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId.toString()
    );
  }
}

export interface IGetAllDriversCommandParameters
  extends ICommandParameters,
    GridRequestDto {
}

export interface IGetAllDriverResponse
  extends DriverResponseDTO,
    ICommandResponse {}
